module.exports = "/_next/static/images/OgInfrastructure-cc8c753da9631553b3096db0d948dd52.jpg";